import { createApp } from 'vue'
import App from './App.vue'
import './styles/main.scss'
import pinia from './store';
import router from './router'
import 'element-plus/dist/index.css'
// 引入echarts
// import echarts from "./utils/echarts";
const app = createApp(App);
app.use(router)
app.use(pinia);
// app.config.globalProperties.$echarts = echarts;
// app.provide('$echarts', echarts)
app.mount('#app')
